import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ConstantAbonnementAppPay {

  readonly THREE_MONTHS = 3;
  readonly PRIX = 69000.00;

}
